import { useSyncExternalStore } from 'react';

/** Minimaler Router: Pfad + Query im URL, Zurück-Taste funktioniert */
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

window.addEventListener('popstate', emit);

/** `state` landet im Verlaufseintrag; beim Ersetzen bleibt der bisherige Zustand erhalten */
export function navigate(to: string, opts: { replace?: boolean; state?: unknown } = {}) {
  if (to === location.pathname + location.search) return;
  if (opts.replace) history.replaceState(opts.state ?? history.state, '', to);
  else history.pushState(opts.state ?? null, '', to);
  emit();
}

export function setQuery(params: Record<string, string | null>, opts: { replace?: boolean; state?: unknown } = {}) {
  const sp = new URLSearchParams(location.search);
  for (const [k, v] of Object.entries(params)) {
    if (v === null) sp.delete(k);
    else sp.set(k, v);
  }
  const qs = sp.toString();
  navigate(location.pathname + (qs ? `?${qs}` : ''), opts);
}

function snapshot() {
  return location.pathname + location.search;
}

export function useLocation() {
  const href = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    snapshot,
  );
  const url = new URL(href, location.origin);
  return { pathname: url.pathname, query: url.searchParams };
}
